/**
 * Trie les données par transmetteur
 * @param {string} label - Le label du transmetteur actuel
 * @param {Object[]} offersByTransmitter - Résultat de la requête du nombre d'offres par transmetteur
 * @param {string} offersByTransmitter[].name - Nom du transmetteur
 * @param {number} offersByTransmitter[].total - Nombre d'offres du transmetteur
 * @returns {number} - Le nombre d'offres du transmetteur actuel
 */
function sortDataByTransmitter(label, offersByTransmitter) {
  let total = 0;

  if (label === "Portail Universitaire")
    // On ajoute, depuis le tableau offersByTransmitter, les données correspondantes aux Portail Universitaire
    ["Admin", "Etudiant", "Personnel", "Alumni"].forEach((transmitter) => {
      total +=
        offersByTransmitter.find((item) => item.name == transmitter)?.total ||
        0;
    });
  else if (label === "Portail Entreprise")
    total =
      offersByTransmitter.find((item) => item.name == "Recruteur")?.total || 0;
  else if (label === "Diffuseurs")
    total =
      offersByTransmitter.find((item) => item.name == "Diffuseur")?.total || 0;
  return total;
}

/**
 * Récupère les données pour le graphique "Provenance des offres en ligne"
 * @param {Object[]} offersByTransmitter - Résultat de la requête du nombre d'offres par transmetteur
 * @param {string} offersByTransmitter[].name - Nom du transmetteur
 * @param {number} offersByTransmitter[].total - Nombre d'offres du transmetteur
 * @returns {NivoPieChartData}
 */
export function getOffersByTransmitterData(offersByTransmitter) {
  // Le tableau labels contient les labels des données (les transmetteurs)
  const labels = ["Diffuseurs", "Portail Universitaire", "Portail Entreprise"];
  // Couleurs des données
  const backgroundColors = ["#fd7f6f", "#7eb0d5", "#b2e061"];
  const chartData = [];

  // On trie les données par transmetteur
  labels.forEach((label, index) => {
    chartData.push({
      name: label,
      id: label,
      value: sortDataByTransmitter(label, offersByTransmitter),
      color: backgroundColors[index],
    });
  });

  return chartData;
}

/**
 * Récupère les données pour le graphique "Provenance des offres du portail univ
 * @param {Object[]} offersByTransmitter - Résultat de la requête du nombre d'offres par transmetteur
 * @param {string} offersByTransmitter[].name - Nom du transmetteur
 * @param {number} offersByTransmitter[].total - Nombre d'offres du transmetteur
 * @returns {NivoPieChartData}
 */
export function getOffersByProfileData(offersByTransmitter) {
  const backgroundColor = ["#59a5d8", "#91e5f6", "#08415C", "#885A89"];
  const chartData = [];

  //? Pour chaque profil, on ajoute les données au tableau
  ["Admin", "Etudiant", "Personnel", "Alumni"].forEach((profile, index) => {
    chartData.push({
      name: profile,
      id: profile,
      value:
        offersByTransmitter.find((item) => item.name == profile)?.total || 0,
      color: backgroundColor[index],
    });
  });

  return chartData;
}
